import { useParams, useNavigate } from "react-router-dom";
import { useFetchOrderDetailsQuery } from "../store/apis/order.api";
import Skeleton from "../components/common/Skeleton";
import OrderItemRecapCard from "../components/items/OrderItemRecapCard";
import { IoMdArrowRoundBack } from "react-icons/io";
import { OrderType } from "../types";

const OrderDetails = () => {
  const { orderId } = useParams<{ orderId: string }>();
  const navigate = useNavigate();

  const { data: order, isFetching } = useFetchOrderDetailsQuery(orderId || "", {
    skip: !orderId,
  });

  if (isFetching) {
    return (
      <div className="container mx-auto px-4 py-8 max-w-2xl">
        <Skeleton
          className="h-64 w-full rounded-lg"
          times={1}
        />
      </div>
    );
  }

  if (!order) {
    return (
      <div className="container mx-auto px-4 py-8 max-w-2xl text-center">
        Commande introuvable
      </div>
    );
  }

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <div className="container mx-auto px-4 py-8 max-w-2xl">
      <div
        className="flex items-center gap-2 cursor-pointer text-gray-600 mb-6 hover:text-primary transition-colors"
        onClick={handleBack}
      >
        <IoMdArrowRoundBack />
        <span className="font-medium">Retour</span>
      </div>

      <div className="bg-white rounded-lg shadow-lg overflow-hidden">
        {/* Header */}
        <div className="bg-primary p-6 text-white">
          <div className="flex justify-between items-center mb-2">
            <h1 className="text-2xl font-bold">Commande #{order.displayId}</h1>
          </div>
          <p className="text-white/80 text-sm">
            {order.createdAt} •{" "}
            {order.OrderType === OrderType.DELIVERY
              ? "Livraison"
              : "À emporter"}
          </p>
        </div>

        {/* Order Items */}
        <div className="p-6">
          <h2 className="text-lg font-semibold mb-4 border-b pb-2">Articles</h2>
          <div className="flex flex-col gap-2">
            {order.cart.map((item, index) => (
              <OrderItemRecapCard
                key={`${item.itemId}-${index}`}
                item={item}
              />
            ))}
          </div>
        </div>

        {/* Payment Info */}
        <div className="bg-gray-50 p-6 border-t border-gray-100">
          <h2 className="text-lg font-semibold mb-4">Paiement</h2>
          <div className="space-y-2 text-sm text-gray-600">
            <div className="flex justify-between">
              <span>Sous-total</span>
              <span>{order.paymentInfo.orderPrice.text}</span>
            </div>

            {order.paymentInfo.fees.map((fee, index) => (
              <div
                key={index}
                className="flex justify-between capitalize"
              >
                <span>
                  {fee.type === "delivery"
                    ? "Frais de livraison"
                    : "Frais de service"}
                </span>
                <span>{fee.value.text}</span>
              </div>
            ))}

            <div className="flex justify-between font-bold text-gray-800 text-lg pt-3 border-t border-gray-200 mt-2">
              <span>Total</span>
              <span>{order.paymentInfo.totalPrice.text}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderDetails;
